module.exports = __webpack_public_path__ + "static/media/redbar.1144ecaa.svg";